module.exports = __webpack_public_path__ + "static/notification-6d6b0e8baef2a443d115b826e0f6cee9.svg";